import React, { useEffect, useState } from "react";
import Main from "../../common/Main/Main";
import Loadspinner from "../../common/Loadspinner";
import QueByMeService from "../../services/QueByMeService";
import PropTypes from "prop-types";
import DataCards2 from "../../common/DataCards2/DataCards2";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";

function QueByMe(props) {
  const [isLoading, setLoading] = useState(false);
  const [queByMe, setQueByMe] = useState([]);
  const [ismore, setMore] = useState(true);

  useEffect(() => {
    getquebyMe(1);
  }, []);

  const getquebyMe = async (page) => {
    let scrollPosition = getFromEncLocalStorage("position");
    setLoading(true);
    let reqBody = {
      limit: 10,
      pageNo: page,
    };
    const res = await QueByMeService.queByMe(reqBody);
    if (res) {
      if (res.length < 10) {
        setMore(false);
      }
      let data = [...queByMe, ...res];
      setQueByMe(data);
    }
    if (props.location.state != undefined) {
      window.scrollTo(0, scrollPosition);
    }
    setLoading(false);
  };

  const rerender = (val) => {
    getquebyMe(val);
  };

  return (
    <Main active={"que_by_me"}>
      <Loadspinner filename="QueByMe.js" isLoading={isLoading} isMiddle="true" />

      <DataCards2
        dataList={queByMe}
        rerenderParentCallback={rerender}
        ismore={ismore}
      />
    </Main>
  );
}

export default QueByMe;

QueByMe.propTypes = {
  location: PropTypes.object,
};
